export class ImpuestoPercepcion{

  leyenda: string;
  valor: number;
  tipoValor: number;
  codigo: number;
  baseCalculo: number;
  observacion: string;
}
